<template>
  <div class="menu-wrapper">

    <!--<router-link :to="'/welcome'">-->
    <el-menu-item :index="'/'" :class="{'submenu-title-noDropdown':!isNest}" style="text-align: center">
      <span style="display: block;width: 100%;text-align: center;font-size: 16px;">用户系统</span>
    </el-menu-item>
    <!--</router-link>-->
    <template v-for="item in routes">

      <router-link v-if="item.childrenMenu.length===0 && item.menuUrl" :to="item.menuUrl"
                   :key="item.menuId">
        <el-menu-item :index="item.menuUrl" :class="{'submenu-title-noDropdown':!isNest}">
          <svg-icon class="svgIcon" v-if="item.menuName&&item.menuIcon" :icon-class="item.menuIcon"></svg-icon>
          <span class="written" v-if="item.menuName" slot="title">{{item.menuUrl}}</span>
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="item.menuUrl||item.menuName" :key="item.menuId">
        <template slot="title">
          <svg-icon class="svgIcon" v-if="item.menuName&&item.menuIcon" :icon-class="item.menuIcon"></svg-icon>
          <span class="written" v-if="item.menuName" slot="title">{{item.menuName}}</span>
        </template>

        <template v-for="child in item.childrenMenu" v-if="!child.hidden">
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.childrenMenu&&child.childrenMenu.length>0"
                        :routes="[child]" :key="child.menuUrl"></sidebar-item>

          <!--<router-link >-->
          <!--:to="child.menuUrl"-->
          <!--:key="child.menuName"-->
          <div v-else @click="flushCom(child.menuUrl)">
            <el-menu-item :index="child.menuUrl">
              <svg-icon class="svgIcon" v-if="child.menuName&&child.menuIcon" :icon-class="child.menuIcon"></svg-icon>
              <span v-if="child.menuName" slot="title">{{child.menuName}}</span>
            </el-menu-item>
          </div>

          <!--</router-link>-->
        </template>
      </el-submenu>

    </template>
  </div>
</template>

<script>
  export default {
    name: 'SidebarItem',
    data() {
      return {
//        currentRoute: this.$route.path
      }
    },
    props: {
      routes: {
        type: Array
      },
      isNest: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      currentRoute() {
        return this.$route.path;
      }
    },
    methods: {
      flushCom: function (val) {
        if (val == this.currentRoute) {
          window.location.reload();
        } else {
          this.$router.replace(val);
        }
      }
    }
  }
</script>
<style>
  .el-menu-item {
    text-align: left;
  }

  .el-menu-item span {
    display: inline-block;
  }

  .el-submenu .el-menu-item {
    padding-left: 20px !important;
  }

  .el-submenu__title {
    padding-left: 8px !important;
  }

  #app .sidebar-container .svg-icon {
    margin-right: 10px !important;
  }

  .el-submenu__icon-arrow {
    right: 15px;
  }

  .el-menu-item.is-active span{
    /*color: rgba(26, 188, 156, 1);*/
  }
  .svgIcon {
    float: left;
    margin-top: 20px;
    margin-left: 10px;
    margin-right: 0px;
  }
  .written {
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue